// 组件对象，大写
import crudQuery from './crudQuery.vue'
export default crudQuery
